import React from "react";
import styled, { css } from "styled-components";

import emptyImageSrc from "assets/images/no_search_resault.png";

interface SearchEmptyProps {
  text?: string;
}

const SearchEmpty = ({ text = "검색 결과가 없습니다." }: SearchEmptyProps) => {
  return (
    <SearchEmptyLayout>
      <img src={emptyImageSrc} alt="no_search_image" />
      <p>{text}</p>
    </SearchEmptyLayout>
  );
};

export default SearchEmpty;

const SearchEmptyLayout = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0rem;
  margin: auto;

  > img {
    width: 33rem;
  }

  > p {
    margin-top: 2.4rem;
    ${({ theme }) => theme.typography.body2.medium};
    color: ${({ theme }) => theme.color.text.secondary};
  }

  ${({ theme }) => css`
    ${theme.media.small} {
      > img {
        width: 19rem;
      }

      > p {
        margin-top: 1rem;
        ${({ theme }) => theme.typography.body3.medium};
      }
    }
  `}
`;
